import { STORAGE_CALC_JOB_ID_KEY } from '../components/common/constants';
import { User } from '../authentication/User.types';

const sessionKey = 'AHU_SESSIONID';
const userKey = 'AHUD_LITE_USER';
const projectIdKey = 'projectId';

export const getSessionId = () => {
    if (typeof sessionStorage === 'undefined') {
        return null;
    }

    return sessionStorage.getItem(sessionKey);
};

export const saveSessionId = (sessionId: string) => {
    sessionStorage.setItem(sessionKey, sessionId);
};

export const removeSessionId = () => {
    sessionStorage.removeItem(sessionKey);
};

export const removeUser = () => {
    sessionStorage.removeItem(userKey);
};

export const saveUser = (user: User) => {
    return sessionStorage.setItem(userKey, JSON.stringify(user));
};

export const getUser = () => {
    const user = sessionStorage.getItem(userKey) ?? '';
    if (!user) {
        return;
    }

    return JSON.parse(user);
};

export const getActiveProject = () => {
    return sessionStorage.getItem(projectIdKey);
};

export const setActiveProject = (projectId: string) => {
    sessionStorage.setItem(projectIdKey, projectId);
};

export const removeActiveProject = () => {
    sessionStorage.removeItem(projectIdKey);
};

export const addCalculationJobIdToSessionStorage = (jobId: string) =>
    sessionStorage.setItem(STORAGE_CALC_JOB_ID_KEY, jobId);

export const clearCalculationJobIdFromSessionStorage = (): void =>
    sessionStorage.removeItem(STORAGE_CALC_JOB_ID_KEY);

export const getCalculationJobIdFromSessionStorage = () =>
    sessionStorage.getItem(STORAGE_CALC_JOB_ID_KEY);
